import * as React from 'react';

const AdminFamily = React.lazy(() => import('./presenter'));

export default () => <AdminFamily />;
